import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ConfigurationItemAuditDialog from "./../../factories/configuration-item-audit-dialog";
function CustomerLocationTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.SelectedLocationId = ko.observable();
    self.SelectedLocation = ko.observable();
    self.LocationButtons = ko.observableArray();
    self.LocationButtons.subscribe(function () {
        self.EnableLocationButtons();
    });
    self.ConfigurationItem = parent;
    self.PageSize = ko.observable(10);
    self.PageIndexLocation = ko.observable(0);
    self.PageIndexLocation.subscribe(function () {
        self.RefreshGridLocation();
    });
    self.TotalRowsLocation = ko.observable(0);
    self.SortingLocation = ko.observableArray();
    self.SortingLocation.subscribe(function () {
        self.RefreshGridLocation();
    });
    self.LocationCollection = ko.observableArray([]);
    self.SelectedLocationRow = ko.observable({});
    var _deleteMessageLocation = Bao.Session.GetMessage("msgDeleteCustomerLocation");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddCustomerLocation":
                self.ShowConfigurationItemLocationDialog(self.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "DeleteCustomerLocation":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageLocation, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DeleteCustomerLocation(self.ConfigurationItem.ConfigurationItemId(), self.SelectedLocationRow().ConfigurationItem200LocationId);
                    }
                });
                break;
            case "ConfigurationItemLocationTabAuditTrail":
                self.AuditTrail();
                break;
        }
    };
    self.UrlAuditTrail = "ConfigurationItemTab/CreateAuditTrailLocation";
    self.UrlAuditTrailOverview = "ConfigurationItemTab/CreateAuditTrailOverviewLocation";
    self.AuditTrail = function () {
        var auditDialog = null;
        if (self.SelectedLocationRow() != null && self.SelectedLocationRow().ConfigurationItem200LocationId != null) {
            auditDialog = new ConfigurationItemAuditDialog(self.SelectedLocationRow().ConfigurationItem200LocationId, ko.unwrap(tabPage.Title), tabPage, self.UrlAuditTrail, false);
        }
        else {
            auditDialog = new ConfigurationItemAuditDialog(self.ConfigurationItem.ConfigurationItemId(), ko.unwrap(tabPage.Title), tabPage, self.UrlAuditTrailOverview, true);
        }
        auditDialog.Open();
    };
    self.RefreshGridLocation = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetCustomerLocationCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.PageIndexLocation(),
            pageSize: self.PageSize(),
            sorting: self.SortingLocation()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedLocationRow(null);
            self.TotalRowsLocation(0);
            self.LocationCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.LocationCollection(searchResult.Models);
                self.TotalRowsLocation(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddConfigurationItemLocation = function (model, configurationItemId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemTab/AddCustomerLocation", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            customerLocationModel: ko.map.toJS(model),
            configurationItemId: configurationItemId
        }), function () {
            self.ConfigurationItem.TabPage.DirtyFlag(true);
            self.RefreshGridLocation();
        });
    };
    self.DeleteCustomerLocation = function (configurationItemId, configurationItemLocationId) {
        return Bao.post("ConfigurationItemTab/DeleteCustomerLocation", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItemLocationId: configurationItemLocationId
        }), function () {
            self.ConfigurationItem.TabPage.DirtyFlag(true);
            self.RefreshGridLocation();
        });
    };
    self.ShowConfigurationItemLocationDialog = function () { };
    self.SelectedLocation.subscribe(function () {
        if (self.SelectedLocation() != null) {
            var myModel = {
                ConfigurationItemId: self.ConfigurationItem.ConfigurationItemId(),
                LocationId: self.SelectedLocation().LocationId,
                LocationName: self.SelectedLocation().Location,
                IsInherited: false
            };
            self.AddConfigurationItemLocation(myModel, self.ConfigurationItem.ConfigurationItemId());
        }
    });
    self.SelectedLocationRow.subscribe(function () {
        self.EnableLocationButtons();
    });
    self.EnableLocationButtons = function () {
        $.each(self.LocationButtons(), function (index, item) {
            if (item.ActionKey() == "DeleteCustomerLocation") {
                if (self.SelectedLocationRow() != null && (self.SelectedLocationRow().IsInherited == null || self.SelectedLocationRow().IsInherited == false)) {
                    item.Enabled(true);
                }
                else {
                    item.Enabled(false);
                }
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("ConfigurationItemTab/ResetCustomerLocation", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId
        }), function () {
            self.RefreshGridLocation().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function (savetime) {
        return Bao.post("ConfigurationItemTab/SaveCustomerLocationCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            saveTime: savetime
        }));
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.init = function () { };
    self.loaded = function () {
        return self.Refresh();
    };
}
Bao.inherit(CustomerLocationTabModel, ChildTabViewModel);
export default CustomerLocationTabModel;